// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"39":"2b4c973fe0224b08","82":"29a2b5650cf8cc40","675":"e093d3174fbbcc76","713":"814f7ee827479e98","897":"d50b64a88d2abdec"}[chunkId] + ".js";
};